module.exports = __webpack_public_path__ + "static/img/6a.617e8947.png";